export default __webpack_public_path__ + "static/1-d199a18dc4428d0b7f509000a9169f64.png";